import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';

import type { OrdersNavSearchData, OrdersNavState } from './orders.nav.types';
import type { RootState } from 'store/root-state';

export const selectSearchData = (state: OrdersNavState): OrdersNavSearchData =>
  get(state, 'searchData', emptyObject as OrdersNavSearchData);
export const selectOrderAlertCount = (state: OrdersNavState): number => get(state, 'orderAlertsCount', 0);
export const selectStatusCountMap = (state: OrdersNavState): Record<string, number> => get(state, 'statusCountMap', emptyObject);

export const selectOrdersNavSearchData = (state: RootState): OrdersNavSearchData => selectSearchData(get(state, 'orders.nav'));
export const selectOrdersNavOrderAlertCount = (state: RootState): number => selectOrderAlertCount(get(state, 'orders.nav'));
export const selectOrdersNavStatusCountMap = (state: RootState): Record<string, number> => selectStatusCountMap(get(state, 'orders.nav'));
